const Errors = {
  SomethingWentWrong: "SomethingWentWrong",
  SomethingWentWrongInLogin: "SomethingWentWrongInLogin",
  SomethingWentWrongTryAgain: "SomethingWentWrongTryAgain",
  SomethingWentWrongLoadingTodos: "SomethingWentWrongLoadingTodos",
  NotEnoughPermissions: "NotEnoughPermissions",
  IncomingInvoiceNotFound: "IncomingInvoiceNotFound",
  IncomingInvoiceIncorrectState: "IncomingInvoiceIncorrectState",
  IncomingInvoiceNoImages: "IncomingInvoiceNoImages",
  IncomingInvoiceCurrencyNotFound: "IncomingInvoiceCurrencyNotFound",
  IncomingInvoiceAmountLessThanZero: "IncomingInvoiceAmountLessThanZero",
  IncomingInvoiceTaxAmountLessThanZero: "IncomingInvoiceTaxAmountLessThanZero",
  IncomingInvoiceDueDateLessThanInvoiceDate: "IncomingInvoiceDueDateLessThanInvoiceDate",
  IncomingInvoiceInvalidInvoiceDate: "IncomingInvoiceInvalidInvoiceDate",
  IncomingInvoiceInvalidDimensionAmount: "IncomingInvoiceInvalidDimensionAmount",
  IncomingInvoiceInvalidDimension: "IncomingInvoiceInvalidDimension",
  IncomingInvoiceNonexistentCompany: "IncomingInvoiceNonexistentCompany",
  IncomingInvoiceNotActivated: "IncomingInvoiceNotActivated",
  IncomingInvoiceSupplierNotFound: "IncomingInvoiceSupplierNotFound",
  IncomingInvoiceInvalidState: "IncomingInvoiceInvalidState",
  IncomingInvoiceAccountRequired: "IncomingInvoiceAccountRequired",
  IncomingInvoicePeriodisationEndBeforeStart: "IncomingInvoicePeriodisationEndBeforeStart",
  IncomingInvoiceImageNotFound: "IncomingInvoiceImageNotFound",
  IncomingInvoicePersonNotFound: "IncomingInvoicePersonNotFound",
  LargerThanMaxFileSize: "LargerThanMaxFileSize",
  EmptyFile: "EmptyFile",
  MaxAmountOfFilesAllowed: "MaxAmountOfFilesAllowed",
  BeyondMaxAmountOfFiles: "BeyondMaxAmountOfFiles",
  InvalidFileType: "InvalidFileType",
  DuplicateCustomer: "DuplicateCustomer",
  DraftAssigneeNotFound: "DraftAssigneeNotFound",
  InvalidStateForUpdate: "InvalidStateForUpdate",
  AlreadyHasSameAssigneeAndState: "AlreadyHasSameAssigneeAndState",
  InvalidStateForReassignment: "InvalidStateForReassignment",
  TimeReportsNotFound: "TimeReportsNotFound",
  PleaseContactSupport: "PleaseContactSupport",
  ErrorBoundaryMessage: "ErrorBoundaryMessage",
  ErrorBoundaryFooterMessage: "ErrorBoundaryFooterMessage",
  NotFoundTitle: "NotFoundTitle",
  NotFoundDescription: "NotFoundDescription",
  NotFoundSelectCompany: "NotFoundSelectCompany",
  }
export default Errors;